import { HogesPrivacyURL, HogesTermsURL } from "constants/registration-links";
import { useDomainHandler } from "hooks/useDomainHandler";
import { useTranslation } from "react-i18next";

interface Link {
  url: string;
  label: string;
  external: boolean;
}

interface FooterConstantsInterface {
  genericLinks: { title: string; links: Link[] };
  contactLinks: { intro: string; links: Link[] };
}

export const FooterConstants = (): FooterConstantsInterface => {
  const { t } = useTranslation("common");

  // Use the useDomainHandler hook to get domain-specific data
  const { getCustomSupportEmailByDomain } = useDomainHandler();

  const genericLinks = {
    title: t("footer.genericLinks.title"),
    links: [
      {
        url: HogesTermsURL,
        label: t("footer.genericLinks.items.terms"),
        external: true,
      },
      /* TODO: restore this link when we know the URL to which it should point to
      {
        url: '/agreement',
        label: 'footer.genericLinks.items.agreement',
      }, */
      {
        url: HogesPrivacyURL,
        label: t("footer.genericLinks.items.privacy"),
        external: true,
      },
    ],
  };

  // t('common:footer.contactLinks.title')
  const contactLinks = {
    intro: t("footer.contactLinks.intro"),
    links: [
      {
        url: `mailto: ${getCustomSupportEmailByDomain()}`,
        label: getCustomSupportEmailByDomain(),
        external: true,
      },
    ],
  };

  return { genericLinks, contactLinks };
};
